import { useQuery } from "@tanstack/react-query";
import Axios from "axios";

const useGuestsLetterStatusQuery = (guestId) => {
  return useQuery({
    queryKey: ["letter-status", guestId],
    queryFn: () => {
      if (!guestId) return;
      return Axios.get(
        `${process.env.REACT_APP_BASE_URL}/guests/${guestId}/letter-printed`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("token"),
          },
        }
      ).then((res) => res.data);
    },
    enabled: !!guestId,
  });
};

export default useGuestsLetterStatusQuery;
